import { Papa } from 'ngx-papaparse';
import { Observable, map } from 'rxjs';
import { ExportField } from '../models';

export class AtsCsv {
	public static download = (blob: Blob, fileName: string): void => {
		const url = window.URL.createObjectURL(blob);
		const anchor = document.createElement('a');
		anchor.download = fileName;
		anchor.href = url;
		anchor.click();
		anchor.remove();
	};

	public static createBlob = (exportData: any[][], headers: string[] = []): Blob => {
		if (!exportData.length && !headers.length) {
			throw new Error('Empty data and headers.');
		}
		const parser = new Papa();
		const parsedData =
			'\uFEFF' + parser.unparse([...[headers], ...exportData], { header: true });
		return new Blob([parsedData], { type: 'text/csv' });
	};

	public static createExportHeaders = <T extends { id: any }>(
		data$: Observable<T[]>,
		exportFieldMap: ExportField<T>[]
	) => {
		return data$.pipe(
			map(data => {
				const headers = exportFieldMap.map(fields => fields.exportHeader);
				const exportFields = exportFieldMap.map(fields => fields.id);
				const exportData = data.map(datum => exportFields.map(field => datum[field] ?? ''));
				return { headers, exportData };
			})
		);
	};

	public static getExportHeaders = <T extends { [key: string]: any }>(
		headerMap: Record<keyof T, string>,
		data: T[]
	): { headers: string[]; exportData: any[][] } => {
		const headers = Object.values(headerMap);
		const exportFields = Object.keys(headerMap);
		const exportData = data.map(datum => exportFields.map(field => datum[field] ?? ''));
		return { headers, exportData };
	};

	public static getExportData = <T extends { [key: string]: any }>(
		data: T[],
		exportFieldMap: ExportField<T>[]
	) => {
		const headers = exportFieldMap.map(fields => fields.exportHeader);
		const exportFields = exportFieldMap.map(fields => fields.id);
		const exportData = data.map(datum => exportFields.map(field => datum[field] ?? ''));
		return { headers, exportData };
	};

	public static parseDataToCSV = (data: any[][], headers?: string[]): string => {
		const parser = new Papa();
		return parser.unparse([...(headers ? [headers] : []), ...[...data]], { header: !!headers });
	};

	public static createBlobFromData = (data: any[][], headers?: string[]): Blob => {
		const csv = this.parseDataToCSV(data, headers);
		return new Blob([csv], { type: 'text/csv' });
	};
}
